import { z } from "zod";
import { ruleStatusSchema, typeLimitSchema } from "../_shared";
import { merchantGroupSchema } from "../../../shared";

export const getActiveByCompanyRequestSchema = z.object({
  companyUuid: z.uuid(),
});

export type GetActiveByCompanyRequest = z.infer<
  typeof getActiveByCompanyRequestSchema
>;

export const getActiveByCompanyRuleSchema = z.object({
  uuid: z.uuid(),
  company: z.uuid(),
  name: z.string(),
  onlyFrance: z.boolean(),
  nationalHolidays: z.boolean(),
  amountLimit: z.number(),
  typeLimit: typeLimitSchema,
  areOtherMerchantsAuthorized: z.boolean(),
  unauthorizedMerchantGroups: z.array(merchantGroupSchema),
  areSupportingDocumentsMandatory: z.boolean(),
  vehicleHasToScan: z.boolean(),
  canPayOnline: z.boolean(),
  status: ruleStatusSchema,
  deletedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
});

export const getActiveByCompanyResponseSchema = z.array(
  getActiveByCompanyRuleSchema,
);

export type GetActiveByCompanyRule = z.infer<
  typeof getActiveByCompanyRuleSchema
>;
export type GetActiveByCompanyResponse = z.infer<
  typeof getActiveByCompanyResponseSchema
>;
